import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=093d9a6a&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('093d9a6a')) {
      api.createRecord('093d9a6a', component.options)
    } else {
      api.reload('093d9a6a', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=093d9a6a&", function () {
      api.rerender('093d9a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-48JmpZ7RNFEFK/JS/comp/IncreaseNumber.vue"
export default component.exports